import { useEffect, useState } from "react"
import { addAdminsToGroup, addUsersToGroup, fetchCreateNewGroup, fetchEditGroup, fetchGroup, fetchGroupAccess, fetchUser, removeAdminsToGroup, removeUsersToGroup, updateUserData, updategroupData } from "../UsersApi";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentLang, selectTranslations } from "../../../services/i18n/i18nSlice";

import trash_img from '../../../assets/images/trash.svg'
import arrow_img from '../../../assets/images/arrow-right.svg'
import inbox_img from '../../../assets/images/inbox.svg'

import { selectUserFields } from "../../../features/User/userSlice";
import { Form, Tab, Tabs } from "react-bootstrap";
import { setLoading } from "../../../services/global/globalSlice";
import { toast } from "react-toastify";
import EditableInput from "../../../components/_form/EditableInput";
import { Stepper, Step } from 'react-form-stepper';
import UserReducedTable from "./UserReducedTable";
import AddUserInput from "./AddUserInput";
import { API_URL } from "../../../config/constants";

export default function GroupModal (props) {

    const dispatch = useDispatch()
    const t = useSelector(selectTranslations)
    const [showModal, setShowModal] = useState(false)
    const [activeStep, setActiveStep] = useState(0)
    const [groupData, setGroupData] = useState({})
    const [groupAccessData, setGroupAccessData] = useState({})
    const [rowSelection, setRowSelection] = useState({})
    const [adminRowSelection, setAdminRowSelection] = useState({})
    const [customUnlockConditions, setCustomUnlockConditions] = useState([])

    const loadGroupData = async () => {
        dispatch(setLoading(true))
        const response = await fetchGroup(props.groupId)
        if(response.success){
            setGroupData(response.data)
            // Load custom unlock conditions if group type is custom_unlock
            if (response.data.type === 'custom_unlock' && response.data.custom_unlock_conditions) {
                setCustomUnlockConditions(response.data.custom_unlock_conditions)
            } else {
                setCustomUnlockConditions([])
            }
            setShowModal(true)
            dispatch(setLoading(false))
        } else {
            toast.error(t.error.error_loading)
            dispatch(setLoading(false))
        }
    }

    const handleUpdateGroupField = (field, value) => {
        let _groupData = structuredClone(groupData)
        _groupData[field] = value
        setGroupData(_groupData)
    }

    const handleAddCustomUnlockCondition = () => {
        const newCondition = {
            condition: '=',
            value: '',
            custom_attribute_field: ''
        }
        setCustomUnlockConditions([...customUnlockConditions, newCondition])
    }

    const handleUpdateCustomUnlockCondition = (index, field, value) => {
        const updatedConditions = [...customUnlockConditions]
        updatedConditions[index][field] = value
        setCustomUnlockConditions(updatedConditions)
    }

    const handleRemoveCustomUnlockCondition = (index) => {
        const updatedConditions = customUnlockConditions.filter((_, i) => i !== index)
        setCustomUnlockConditions(updatedConditions)
    }

    const validateCustomUnlockConditions = () => {
        if (groupData.type !== 'custom_unlock') return true
        
        // Check if all conditions have required fields
        return customUnlockConditions.every(condition => 
            condition.custom_attribute_field.trim() !== '' && 
            condition.value.trim() !== ''
        )
    }

    const handleUpdateGroupData = async () => {
        // Validate custom unlock conditions
        if (!validateCustomUnlockConditions()) {
            toast.error(t.groups.invalid_conditions || 'Tutte le condizioni di sblocco devono avere campo attributo e valore compilati')
            return
        }

        let group_data = {
            name: groupData.name,
            group_id: props.groupId,
            is_deleted: groupData.is_deleted,
            type: groupData.type || 'default',
            users_ids: groupData.users_data?.map(u => u.user_id) || [],
            admins_data: groupData.admins_data?.map(u => u.user_id) || [],
        }
        
        // Add custom unlock conditions if type is custom_unlock
        if (groupData.type === 'custom_unlock') {
            group_data.custom_unlock_conditions = customUnlockConditions
        }
        
        const response = await fetchEditGroup(group_data)
        if(response.success){
            toast.success(t.groups.group_edited)
            setShowModal(false)
            props.onCloseModal()
        } else {
            toast.error(t.groups.error_editing_group)
        }
    };

    const handleCreateGroupData = async (event) => {
        // Validate custom unlock conditions
        if (!validateCustomUnlockConditions()) {
            toast.error(t.groups.invalid_conditions || 'Tutte le condizioni di sblocco devono avere campo attributo e valore compilati')
            return
        }

        let group_data = {
            name: groupData.name,
            type: groupData.type || 'default',
            users_ids: groupData.users_data?.map(u => u.user_id) || [],
            admins_ids: []
        }
        
        // Add custom unlock conditions if type is custom_unlock
        if (groupData.type === 'custom_unlock') {
            group_data.custom_unlock_conditions = customUnlockConditions
        }
        
        const response = await fetchCreateNewGroup(group_data)
        if(response.success){
            toast.success(t.groups.group_created)
            setShowModal(false)
            props.onCloseModal()
        } else {
            toast.error(t.groups.error_creating_group)
        }
    };

    const handleAddUser = async (user) => {
        if(props.isNew){
            setGroupData({
                ...groupData,
                users_data: [...groupData?.users_data || [], user]
            })
        } else {
            const users_ids = [user.user_id]
            const response = await addUsersToGroup({group_id: props.groupId},{users_ids: users_ids})
            if (response.success) {
                toast.success(t.groups.user_added)
                setGroupData({
                    ...groupData,
                    users_data: [...groupData.users_data, user]
                })
            } else {
                toast.error(t.error.error_loading)
            } 
        }
        
    }

    const handleAddAdmin = async (user) => {
        const users_ids = [user.user_id]
        const response = await addAdminsToGroup({group_id: props.groupId},{users_ids: users_ids})
        if (response.success) {
            toast.success(t.groups.user_added)
            setGroupData({
                ...groupData,
                admins_data: [...groupData?.admins_data, user]
            })
        } else {
            toast.error(t.error.error_loading)
        }
    }

    const handleRemoveUsers = async () => {
        const users_ids = Object.keys(rowSelection)
        if(users_ids?.length > 0){
            const response = await removeUsersToGroup({group_id: props.groupId},{users_ids: users_ids})
            if (response.success) {
                toast.success(t.groups.users_removed)
                loadGroupData()
            } else {
                toast.error(t.error.error_loading)
            }
        } else 
            return;
    }

    const handleRemoveAdmins = async () => {
        const users_ids = Object.keys(adminRowSelection)
        if(users_ids?.length > 0){
            const response = await removeAdminsToGroup({group_id: props.groupId},{users_ids: users_ids})
            if (response.success) {
                toast.success(t.groups.users_removed)
                loadGroupData()
            } else {
                toast.error(t.error.error_loading)
            }
        } else 
            return;
    }

    const loadGroupAccess = async () => {
            const response = await fetchGroupAccess(props.groupId)
            if(response.success){
                setGroupAccessData(response.data?.folders?.filter(f => f.state !== "deleted"))
            } else {
                toast.error(t.user.error_loading_access)
            }
        }

    const onClose = () => {
        setShowModal(false)
        props.onCloseModal()
    }

    useEffect(()=>{
        if(props.groupId){
            loadGroupData()
            loadGroupAccess()
        }
        if(props.isNew){
            setShowModal(true)
            setGroupData({
                is_deleted: false,
                type: 'default',
                name: ''
            })
            setCustomUnlockConditions([])
            setActiveStep(0)
        }
    },[props.groupId, props.isNew])

    return (
        <Modal
            show={showModal}
            keyboard={false}
            centered
            size={'lg'}
        >
            <Modal.Body>
                {!props.isNew ?
                <>
                    <div className="d-flex justify-content-between">
                        <EditableInput value={groupData.name} onChange={(e)=>handleUpdateGroupField('name',e.target.value)} style={{fontSize:"32px",fontWeight:"700"}} />
                    </div>
                                        
                    <Tabs
                        defaultActiveKey="components"
                        id="noanim-tab-example"
                        className="mt-3 mb-4 rounded_tabs"
                    >
                        <Tab eventKey="info" title={`${t.groups.info}`}>
                            <div className="mb-2">
                                <div className="mt-3">
                                    <div className="mb-3">
                                        <Form.Check
                                            inline
                                            label="Eliminato"
                                            name="type"
                                            type={'switch'}
                                            id={`is_deleted`}
                                            value={'is_deleted'}
                                            checked={groupData?.is_deleted}
                                            onChange={(e)=>handleUpdateGroupField('is_deleted',e.target.checked)}
                                        />
                                    </div>
                                    <Form.Label>{t.groups.type}</Form.Label>
                                    <div className="mb-3">
                                        <Form.Check
                                            inline
                                            label="Standard"
                                            name="type"
                                            type={'radio'}
                                            id={`edit_default`}
                                            value={'default'}
                                            checked={groupData?.type === 'default' || !groupData?.type }
                                            onChange={(e)=>handleUpdateGroupField('type',e.target.value)}
                                        />
                                        <Form.Check
                                            inline
                                            label="Sblocco Automatico"
                                            name="type"
                                            type={'radio'}
                                            id={`edit_custom_unlock`}
                                            value="custom_unlock"
                                            checked={groupData?.type === 'custom_unlock'}
                                            onChange={(e)=>handleUpdateGroupField('type',e.target.value)}
                                        />
                                    </div>
                                    
                                    {/* Custom Unlock Conditions for Edit Mode */}
                                    {groupData?.type === 'custom_unlock' && (
                                        <div className="mt-4">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h5>{t.groups.custom_unlock_conditions || 'Condizioni di Sblocco'}</h5>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={handleAddCustomUnlockCondition}
                                                >
                                                    {t.groups.add_condition || 'Aggiungi Condizione'}
                                                </button>
                                            </div>
                                            
                                            {customUnlockConditions.length === 0 ? (
                                                <div className="text-center text-muted py-3">
                                                    <p>{t.groups.no_conditions || 'Nessuna condizione definita. Aggiungi una condizione per configurare lo sblocco automatico.'}</p>
                                                </div>
                                            ) : (
                                                <div className="custom-unlock-conditions">
                                                    {customUnlockConditions.map((condition, index) => (
                                                        <div key={index} className="card mb-3">
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-md-4 auto-width">
                                                                        <Form.Label>{t.groups.attribute_field || 'Campo Attributo'}</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={condition.custom_attribute_field}
                                                                            onChange={(e) => handleUpdateCustomUnlockCondition(index, 'custom_attribute_field', e.target.value)}
                                                                            placeholder={t.groups.attribute_field_placeholder || 'es. user_level'}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 auto-width">
                                                                        <Form.Label>{t.groups.condition || 'Condizione'}</Form.Label>
                                                                        <Form.Select
                                                                            value={condition.condition}
                                                                            onChange={(e) => handleUpdateCustomUnlockCondition(index, 'condition', e.target.value)}
                                                                        >
                                                                            <option value="=">=</option>
                                                                            <option value="!=">!=</option>
                                                                            <option value=">">&gt;</option>
                                                                            <option value="<">&lt;</option>
                                                                            <option value=">=">&gt;=</option>
                                                                            <option value="<=">&lt;=</option>
                                                                            <option value="IN">IN</option>
                                                                            <option value="NOT_IN">NOT IN</option>
                                                                        </Form.Select>
                                                                    </div>
                                                                    <div className="col-md-4 auto-width">
                                                                        <Form.Label>{t.groups.value || 'Valore'}</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={condition.value}
                                                                            onChange={(e) => handleUpdateCustomUnlockCondition(index, 'value', e.target.value)}
                                                                            placeholder={t.groups.value_placeholder || 'es. 5 o admin,user'}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-1 d-flex align-items-end">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-danger btn-sm"
                                                                            onClick={() => handleRemoveCustomUnlockCondition(index)}
                                                                            title={t.groups.remove_condition || 'Rimuovi condizione'}
                                                                        >
                                                                            <img src={trash_img} alt="Remove" style={{width: '16px', height: '16px'}} />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Tab>
                        <Tab eventKey="components" title={`${t.groups.components} (${groupData.users_data?.length})`}>
                            <div className="d-flex justify-content-between mb-2">
                                <AddUserInput onAddUser={handleAddUser} invalidUsers={groupData?.users_data?.map(u => u.user_id)} label={t.groups.add_user}/>
                                <div className='d-flex pointer' style={{color:"#181818",fontWeight:"500"}}>
                                    <div className='d-flex table_action' onClick={Object.keys(rowSelection).length > 0 ? handleRemoveUsers : null} disabled={Object.keys(rowSelection).length <= 0}>
                                        <img src={trash_img} />
                                        {t.groups.remove_user}
                                    </div>
                                </div>
                            </div>
                            <UserReducedTable data={groupData.users_data} rowSelection={rowSelection} setRowSelection={setRowSelection} />
                        </Tab>
                        <Tab eventKey="admins" title={`${t.groups.admins} (${groupData.admins_data?.length})`}>
                            <div className="d-flex justify-content-between mb-2">
                                <AddUserInput onAddUser={handleAddAdmin} invalidUsers={groupData?.admins_data?.map(u => u.user_id)} label={t.groups.add_admin} filters={{is_admin:true}}/>
                                <div className='d-flex pointer' style={{color:"#181818",fontWeight:"500"}}>
                                    <div className='d-flex table_action' onClick={Object.keys(adminRowSelection).length > 0 ? handleRemoveAdmins : null} disabled={Object.keys(adminRowSelection).length <= 0}>
                                        <img src={trash_img} />
                                        {t.groups.remove_admin}
                                    </div>
                                </div>
                            </div>
                            <UserReducedTable data={groupData.admins_data} rowSelection={adminRowSelection} setRowSelection={setAdminRowSelection} />
                        </Tab>
                        <Tab eventKey="access" title={`${t.user.access_data} (${groupAccessData?.length || 0})`}>
                            {
                                !(groupAccessData?.length > 0) ?
                                    <p className="text-muted">{t.groups.no_folder_access}</p> :
                                    <ul>
                                        {Object.keys(Object.groupBy(groupAccessData, ({ parent_folder_id }) => parent_folder_id)).map((key,index)=>{
                                            if(
                                                ( groupAccessData.find(f => f.folder_id === key) &&
                                                !groupAccessData.find(f => f.folder_id === groupAccessData.find(f => f.folder_id === key)?.parent_folder_id) ) ||
                                                !groupAccessData.find(f => f.folder_id === key)
                                            )
                                                return(
                                                    <li key={index} className="mb-3">
                                                        {
                                                            groupAccessData.find(f => f.folder_id === key)?.icon_url &&
                                                                <img src={`${API_URL}${groupAccessData.find(f => f.folder_id === key).icon_url}`} className="me-2" style={{maxWidth:"20px"}} />
                                                        }
                                                        {groupAccessData.find(f => f.folder_id === key)?.name}
                                                        <ul>
                                                            <RenderedSubfolder groupAccessData={groupAccessData} folderId={key} />
                                                        </ul>
                                                    </li>
                                                )
                                        })}
                                    </ul>
                            }
                        </Tab>
                    </Tabs>
                    <div className="mt-4 d-flex w-100 justify-content-between">
                        <button className="secondary" onClick={onClose}>
                            {t.buttons.exit_without_save}
                        </button>
                        <button type="button" onClick={handleUpdateGroupData}>
                            {t.buttons.save_and_exit}
                        </button>
                    </div>
                </> : 
                <>
                    <Stepper 
                        activeStep={activeStep}
                        styleConfig={{
                            activeBgColor: "#436094",
                            completedBgColor: "#436094",
                            inactiveBgColor: "#E2E2E2"
                        }}
                    >
                        <Step label={t.groups.details} onClick={()=>setActiveStep(0)}/>
                        <Step label={t.groups.components} onClick={()=>setActiveStep(1)}/>
                        <Step label={t.groups.access} onClick={()=>setActiveStep(2)}/>
                    </Stepper>
                    {
                        activeStep === 0 ?
                        <div>
                            <h2>{t.groups.name}</h2>
                            <Form.Group className="mt-2">
                                <Form.Label>{t.groups.name}</Form.Label>
                                <Form.Control className="auto-width"  type={'text'} value={groupData?.name || '' } onChange={(e)=>handleUpdateGroupField('name',e.target.value)} placeholder={t.groups.add_group_name}/>
                            </Form.Group>
                            <Form.Label className='mt-3'>{t.groups.type}</Form.Label>
                            <div className="mb-3">
                                <Form.Check
                                    inline
                                    label="Standard"
                                    name="type"
                                    type={'radio'}
                                    id={`default`}
                                    value={'default'}
                                    checked={groupData?.type === 'default' || !groupData?.type }
                                    onChange={(e)=>handleUpdateGroupField('type',e.target.value)}
                                />
                                <Form.Check
                                    inline
                                    label="Sblocco Automatico"
                                    name="type"
                                    type={'radio'}
                                    id={`custom_unlock`}
                                    value="custom_unlock"
                                    checked={groupData?.type === 'custom_unlock'}
                                    onChange={(e)=>handleUpdateGroupField('type',e.target.value)}
                                />
                            </div>
                            
                            {/* Custom Unlock Conditions */}
                            {groupData?.type === 'custom_unlock' && (
                                <p>Una volta creato il gruppo sarà possibile definire le condizioni di sblocco</p>
                            )}
                            <div className="mt-4 d-flex w-100 justify-content-between">
                                <button className="secondary" onClick={onClose}>
                                    {t.buttons.exit_without_save}
                                </button>
                                <button type="button" onClick={()=>setActiveStep(1)} disabled={!groupData?.name}>
                                    {t.groups.components}
                                    <img src={arrow_img} />
                                </button>
                            </div>
                        </div>
                        : null
                    }
                    {
                        activeStep === 1 ?
                        <div>
                            <div className="d-flex justify-content-between mb-2">
                                <AddUserInput onAddUser={handleAddUser} invalidUsers={groupData?.users_data?.map(u => u.user_id)} label={t.groups.add_user}/>
                                <div className='d-flex pointer' style={{color:"#181818",fontWeight:"500"}}>
                                    <div className='d-flex table_action' onClick={Object.keys(rowSelection).length > 0 ? handleRemoveUsers : null} disabled={Object.keys(rowSelection).length <= 0}>
                                        <img src={trash_img} />
                                        {t.groups.remove_user}
                                    </div>
                                </div>
                            </div>
                            <UserReducedTable data={groupData.users_data} rowSelection={rowSelection} setRowSelection={setRowSelection} />
                            <div className="mt-4 d-flex w-100 justify-content-between">
                                <button className="secondary" onClick={onClose}>
                                    {t.buttons.exit_without_save}
                                </button>
                                <button type="button" onClick={()=>setActiveStep(2)}>
                                    {t.groups.access}
                                    <img src={arrow_img} />
                                </button>
                            </div>
                        </div>
                        : null
                    }
                    {
                        activeStep === 2 ?
                        <div>
                            <div className="text-center">
                                <img src={inbox_img} />
                                <h3>{t.groups.no_access_title}</h3>
                                <p style={{maxWidth:"350px"}} className="mx-auto">{t.groups.no_access_text}</p>
                            </div>
                            <div className="mt-4 d-flex w-100 justify-content-between">
                                <button className="secondary" onClick={onClose}>
                                    {t.buttons.exit_without_save}
                                </button>
                                <button type="button" onClick={handleCreateGroupData}>
                                    {t.buttons.save_create}
                                </button>
                            </div>
                        </div>
                        : null
                    }
                </> 
                }
            </Modal.Body>
        </Modal>
    )
}

function RenderedSubfolder ({groupAccessData, folderId}) {
    return(
        <>
            {groupAccessData.map((folder,i_1)=>{
                if(folder.parent_folder_id === folderId)
                    return(
                        <li key={i_1}>
                            {
                                folder?.icon_url &&
                                    <img src={`${API_URL}${folder.icon_url}`} className="me-2" style={{maxWidth:"20px"}} />
                            }
                            {folder.name}
                            <ul>
                                <RenderedSubfolder groupAccessData={groupAccessData} folderId={folder.folder_id} />
                            </ul>
                        </li>
                    )
            })}
        </>
    )
}